// If you are adding a term to the ActionSubjectId glossary,
// please add a member of the Data team to your PR

// For help naming UI components, see:
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329336/UI+Events

// For help naming track event entities, see:
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329319/Track+Events

const buttons = {
  actionableTaskButton: 'actionableTaskButton',
  addAnotherCardButton: 'addAnotherCardButton',
  addAnotherListButton: 'addAnotherListButton',
  addTeamFromCollectionsButton: 'addTeamFromCollectionsButton',
  addToEnterpriseButton: 'addToEnterpriseButton',
  allBoardMembersButton: 'allBoardMembersButton',
  atlassianAccountOnboardingBannerSnoozeButton:
    'atlassianAccountOnboardingBannerSnoozeButton',
  atlassianAccountCompleteOnboardingSuccessButton:
    'atlassianAccountCompleteOnboardingSuccessButton',
  atlassianOnboardingHelpDocButton: 'atlassianOnboardingHelpDocButton',
  atlassianOnboardingMixedUseAccountButton:
    'atlassianOnboardingMixedUseAccountButton',
  atlassianAccountOnboardingForWorkButton:
    'atlassianAccountOnboardingForWorkButton',
  atlassianOnboardingGoToSettingsToRemoveEmailButton:
    'atlassianOnboardingGoToSettingsToRemoveEmailButton',
  atlassianOnboardingLoginWithAtlassianButton:
    'atlassianOnboardingLoginWithAtlassianButton',
  atlassianOnboardingMenuBackButton: 'atlassianOnboardingMenuBackButton',
  atlassianAccountOnboardingNotWorkButton:
    'atlassianAccountOnboardingNotWorkButton',
  atlassianAccountOnboardingOverlayCloseButton:
    'atlassianAccountOnboardingOverlayCloseButton',
  atlassianOnboardingPersonalAccountButton:
    'atlassianOnboardingPersonalAccountButton',
  atlassianOnboardingRemoveEmailButton: 'atlassianOnboardingRemoveEmailButton',
  atlassianSwitcherHeaderButton: 'atlassianSwitcherHeaderButton',
  attachmentGetPowerEnableButton: 'attachmentGetPowerEnableButton',
  avatarGravatarOptionButton: 'avatarGravatarOptionButton',
  avatarNoneOptionButton: 'avatarNoneOptionButton',
  avatarPreviouslyUploadedOptionButton: 'avatarPreviouslyUploadedOptionButton',
  bcUpgradeFromTemplatesPowerUpButton: 'bcUpgradeFromTemplatesPowerUpButton',
  boardButton: 'boardButton', // for power-up board buttons
  boardDirectoryCloseButton: 'boardDirectoryCloseButton',
  boardMenuDrawerCloseButton: 'boardMenuDrawerCloseButton',
  boardsMenuButton: 'boardsMenuButton',
  calendarPowerUpBoardButton: 'calendarPowerUpBoardButton',
  cancelButton: 'cancelButton',
  cancelEditDescriptionButton: 'cancelEditDescriptionButton',
  cardComposerMenuButton: 'cardComposerMenuButton',
  cardMapEditLocationButton: 'cardMapEditLocationButton',
  cardMapLocationButton: 'cardMapLocationButton',
  changeBoardOrganizationButton: 'changeBoardOrganizationButton',
  changeBoardVisibilityButton: 'changeBoardVisibilityButton',
  changeEmailButton: 'changeEmailButton',
  clearBoardFilterButton: 'clearBoardFilterButton',
  convertToTemplateButton: 'convertToTemplateButton',
  copyBoardButton: 'copyBoardButton',
  copyLinkButton: 'copyLinkButton',
  createBoardButton: 'createBoardButton',
  createCardButton: 'createCardButton',
  createCardFromTemplateButton: 'createCardFromTemplateButton',
  createNewAccountButton: 'createNewAccountButton',
  dismissButton: 'dismissButton',
  editDescriptionButton: 'editDescriptionButton',
  emptyPowerUpSlotButton: 'emptyPowerUpSlotButton',
  enterpriseButton: 'enterpriseButton',
  exportButton: 'exportButton',
  boardFilterButton: 'boardFilterButton',
  formattingHelpDescriptionButton: 'formattingHelpDescriptionButton',
  inviteTeamMembersButton: 'inviteTeamMembersButton',
  inviteToBoardButton: 'inviteToBoardButton',
  inviteToBoardLinkCopyButton: 'inviteToBoardLinkCopyButton',
  joinBoardButton: 'joinBoardButton',
  linkCopyButton: 'linkCopyButton',
  listMenuButton: 'listMenuButton',
  marketingOptInButton: 'marketingOptInButton',
  marketingOptOutButton: 'marketingOptOutButton',
  powerUpAddButton: 'powerUpAddButton',
  powerUpEditButton: 'powerUpEditButton',
  removeEmailButton: 'removeEmailButton',
  setAsPrimaryEmailButton: 'setAsPrimaryEmailButton',
  setUpAtlassianAccountAndRemoveEmailsButton:
    'setUpAtlassianAccountAndRemoveEmailsButton',
  shareButton: 'shareButton',
  showAllActivityButton: 'showAllActivityButton',
  showAllPowerUpsButton: 'showAllPowerUpsButton',
  showCommentsOnlyButton: 'showCommentsOnlyButton',
  showFewerPowerUpsButton: 'showFewerPowerUpsButton',
  showFullDescriptionButton: 'showFullDescriptionButton',
  signUpButton: 'signUpButton',
  upgradeButton: 'upgradeButton',
  upgradeToBCButton: 'upgradeToBCButton',
  useTemplateButton: 'useTemplateButton',
  viewTemplateButton: 'viewTemplateButton',
  copyTemplateButton: 'copyTemplateButton',
  dismissTemplateButton: 'dismissTemplateButton',
  changeOrgProfileButton: 'changeOrgProfileButton',
  unfurlActionButton: 'unfurlActionButton',
} as const;

const links = {
  alwaysKeepMenuOpenLink: 'alwaysKeepMenuOpenLink',
  atlassianAccessSeeDetailsLink: 'atlassianAccessSeeDetailsLink',
  attachmentGetPowerLearnMoreLink: 'attachmentGetPowerLearnMoreLink',
  backgroundOptionsLink: 'backgroundOptionsLink',
  bcUpgradeFromTemplatesPowerUpDescriptionLink:
    'bcUpgradeFromTemplatesPowerUpDescriptionLink',
  bcUpgradeFromTemplatesStoryHeaderLink:
    'bcUpgradeFromTemplatesStoryHeaderLink',
  boardMenuPowerUpLink: 'boardMenuPowerUpLink',
  boardMenuDrawerToggleLink: 'boardMenuDrawerToggleLink', // 'Show Menu' link in board header
  boardSearchResultLink: 'boardSearchResultLink',
  businessClassLink: 'businessClassLink',
  cardMapExternalLink: 'cardMapExternalLink',
  cardSearchResultLink: 'cardSearchResultLink',
  categoryNavLink: 'categoryNavLink',
  changePasswordLink: 'changePasswordLink',
  createBoardLink: 'createBoardLink',
  createCollectionLink: 'createCollectionLink',
  createNewOrgLink: 'createNewOrgLink',
  customPowerUpLearnMoreHeaderLink: 'customPowerUpLearnMoreHeaderLink',
  downloadLink: 'downloadLink',
  enterpriseLink: 'enterpriseLink',
  fullNameProfileLink: 'fullNameProfileLink',
  goldLink: 'goldLink',
  integrationsNavigationMenuLink: 'integrationsNavigationMenuLink',
  inviteTeamMemberLink: 'inviteTeamMemberLink',
  inviteToBoardDisableLink: 'inviteToBoardDisableLink',
  inviteToBoardLink: 'inviteToBoardLink',
  learnMoreLink: 'learnMoreLink',
  mapLocationPowerUpLink: 'mapLocationPowerUpLink',
  memberSearchResultLink: 'memberSearchResultLink',
  moonshotExploreLink: 'moonshotExploreLink',
  seeClosedBoardsLink: 'seeClosedBoardsLink',
  shareTemplateLink: 'shareTemplateLink',
  showLessActiveBoardsLink: 'showLessActiveBoardsLink',
  showMoreCardsLink: 'showMoreCardsLink',
  showSearchTipsLink: 'showSearchTipsLink',
  startWithTemplateLink: 'startWithTemplateLink',
  teamBillingPageLink: 'teamBillingPageLink',
  teamInvitation: 'teamInvitation',
  teamPageLink: 'teamPageLink',
  teamSearchResultLink: 'teamSearchResultLink',
  templatesHelpLink: 'templatesHelpLink',
  updateBillingInfoLink: 'updateBillingInfoLink',
  upgradeBrowserLink: 'upgradeBrowserLink',
} as const;

const inputFields = {
  boardNameInput: 'boardNameInput',
  linkCopyInput: 'linkCopyInput',
  searchInput: 'searchInput',
  fileInputUpload: 'fileInputUpload',
} as const;

const pills = {
  bcUpgradePill: 'bcUpgradePill',
} as const;

// For links in the board menu drawer
const drawerNavigationItems = {
  changeOrgDrawerNavigationItem: 'changeOrgDrawerNavigationItem',
  closeBoardDrawerNavigationItem: 'closeBoardDrawerNavigationItem',
  convertToBoardDrawerNavigationItem: 'convertToBoardDrawerNavigationItem',
  commentPermsDrawerNavigationItem: 'commentPermsDrawerNavigationItem',
  cookieConsentDrawerNavigationItem: 'cookieConsentDrawerNavigationItem',
  copyBoardDrawerNavigationItem: 'copyBoardDrawerNavigationItem',
  invitationsPermsDrawerNavigationItem: 'invitationsPermsDrawerNavigationItem',
  leaveDrawerNavigationItem: 'leaveDrawerNavigationItem',
  makeTemplateFromBoardDrawerNavigationItem:
    'makeTemplateFromBoardDrawerNavigationItem',
  powerUpDirectoryDrawerNavigationItem: 'powerUpDirectoryDrawerNavigationItem',
  removeOrgDrawerNavigationItem: 'removeOrgDrawerNavigationItem',
  selfJoinDrawerNavigationItem: 'selfJoinDrawerNavigationItem',
  votingPermsDrawerNavigationItem: 'votingPermsDrawerNavigationItem',
  watchDrawerNavigationItem: 'watchDrawerNavigationItem',
} as const;

// For info boxes, callouts within a component
const overlays = {
  collectionsExplainerOverlay: 'collectionsExplainerOverlay',
} as const;

// For options within a dropdown component
const dropdownItems = {
  inviteTeamToBoardDropdownItem: 'inviteTeamToBoardDropdownItem',
} as const;

// For tracking set, change, etc of board preferences
const boardPrefs = {
  hideVotesBoardPref: 'hideVotesBoardPref',
  votingBoardPref: 'votingBoardPref',
} as const;

const shortcuts = {
  boardsMenuShortcut: 'boardsMenuShortcut',
  escapeShortcut: 'escapeShortcut',
  searchShortcut: 'searchShortcut',
  myCardsShortcut: 'myCardsShortcut',
  clearAllFiltersShortcut: 'clearAllFiltersShortcut',
  toggleBoardMenuDrawerShortcut: 'toggleBoardMenuDrawerShortcut',
  toggleLabelTextShortcut: 'toggleLabelTextShortcut',
  moveDownShortcut: 'moveDownShortcut',
  moveUpShortcut: 'moveUpShortcut',
  moveLeftShortcut: 'moveLeftShortcut',
  moveRightShortcut: 'moveRightShortcut',
  insertCardShortcut: 'insertCardShortcut',
} as const;

const menuItems = {
  addCardMenuItem: 'addCardMenuItem',
  archiveAllCardsMenuItem: 'archiveAllCardsMenuItem',
  copyListMenuItem: 'copyListMenuItem',
  moveAllCardsMenuItem: 'moveAllCardsMenuItem',
  moveListMenuItem: 'moveListMenuItem',
  sortListMenuItem: 'sortListMenuItem',
} as const;

const emailHygieneTerms = {
  emailHygieneBannerLink: 'emailHygieneBannerLink',
  emailHygieneWizard: 'emailHygieneWizard',
  emailHygieneWizardChangeEmailButton: 'emailHygieneWizardChangeEmailButton',
  emailHygieneWizardConfirmEmailButton: 'emailHygieneWizardConfirmEmailButton',
  emailHygieneWizardEmailItem: 'emailHygieneWizardEmailItem',
  emailHygieneWizardRemoveSecondaryEmailsButton:
    'emailHygieneWizardRemoveSecondaryEmailsButton',
  emailHygieneWizardScreenChooseEmail: 'emailHygieneWizardScreenChooseEmail',
  emailHygieneWizardScreenClaimableInfo:
    'emailHygieneWizardScreenClaimableInfo',
  emailHygieneWizardScreenConfirmationEmailSent:
    'emailHygieneWizardScreenConfirmationEmailSent',
  emailHygieneWizardScreenConfirmSingleEmail:
    'emailHygieneWizardScreenConfirmSingleEmail',
  emailHygieneWizardScreenError: 'emailHygieneWizardScreenError',
  emailHygieneWizardScreenSuccess: 'emailHygieneWizardScreenSuccess',
  emailHygieneTransferBoardsFooterLink: 'emailHygieneTransferBoardsFooterLink',
};

const otherActionSubjectIds = {
  atlassianAccountOnboardingOverlay: 'atlassianAccountOnboardingOverlay',
  bcFreeTrial: 'bcFreeTrial',
  bcFreeTrialUpsell: 'bcFreeTrialUpsell',
  bcPayment: 'bcPayment',
  bcTeam: 'bcTeam',
  bcUpgradePrompt: 'bcUpgradePrompt',
  bcUpgradeSurvey: 'bcUpgradeSurvey',
  boardDescription: 'boardDescription',
  boardInvitation: 'boardInvitation', // Adding members to board
  boardsMenuInlineDialog: 'boardsMenuInlineDialog',
  businessClassUpgrade: 'businessClassUpgrade',
  cardComposerList: 'cardComposerList',
  cardComposerPosition: 'cardComposerPosition',
  cardDescription: 'cardDescription',
  cardMapLocation: 'cardMapLocation',
  cardMember: 'cardMember',
  cardTitleSeparator: 'cardTitleSeparator',
  closedBoardsModal: 'closedBoardsModal',
  colorBlindFriendlyMode: 'colorBlindFriendlyMode',
  colorBoardBackground: 'colorBoardBackground',
  commentReaction: 'commentReaction',
  createBoardBackgroundChooserDialog: 'createBoardBackgroundChooserDialog',
  customBoardBackground: 'customBoardBackground',
  descriptionEdit: 'descriptionEdit',
  emailBoardInvitation: 'emailBoardInvitation', // For new members invited to board
  freeTeam: 'freeTeam',
  fullUpgradePrompt: 'fullUpgradePrompt',
  homeTab: 'homeTab', // Tabs are deprecated; use screens in `Source.ts`
  leaveBoardMenu: 'leaveBoardMenu',
  listLimit: 'listLimit',
  marketingEmail: 'marketingEmail',
  moonshotStep: 'moonshotStep',
  miniProfileAvatar: 'miniProfileAvatar',
  photoBoardBackground: 'photoBoardBackground',
  powerUpCard: 'powerUpCard',
  reactionMenuIcon: 'reactionMenuIcon',
  reactionSelectorInlineDialog: 'reactionSelectorInlineDialog',
  savingSearchQuery: 'savingSearchQuery',
  searchInlineDialog: 'searchInlineDialog',
  searchMember: 'searchMember',
  searchResultCard: 'searchResultCard',
  searchSuggestion: 'searchSuggestion',
  searchTeam: 'searchTeam',
  templatePreview: 'templatePreview',
  templateTile: 'templateTile',
  teamTemplatePicker: 'teamTemplatePicker',
  unknown: 'unknown', // This represents a generic error case and should be used sparingly!
} as const;

export const ActionSubjectId = {
  ...buttons,
  ...links,
  ...inputFields,
  ...pills,
  ...drawerNavigationItems,
  ...overlays,
  ...dropdownItems,
  ...boardPrefs,
  ...otherActionSubjectIds,
  ...shortcuts,
  ...menuItems,
  ...emailHygieneTerms,
} as const;

export type ActionSubjectIdType = typeof ActionSubjectId[keyof typeof ActionSubjectId];

export const isValidActionSubjectId = (a: ActionSubjectIdType) => {
  const validSources = Object.values(ActionSubjectId);
  return validSources.includes(a);
};
